import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Home from "@/pages/Home";
import Trattamenti from "@/pages/Trattamenti";
import ChiSono from "@/pages/ChiSono";
import Studio from "@/pages/Studio";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import Prenota from "@/pages/Prenota";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <div className="grain" aria-hidden="true" />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/trattamenti" element={<Trattamenti />} />
                        <Route path="/chi-sono" element={<ChiSono />} />
                        <Route path="/lo-studio" element={<Studio />} />
                        <Route path="/recensioni" element={<Recensioni />} />
                        <Route path="/contatti" element={<Contatti />} />
                        <Route path="/prenota" element={<Prenota />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingActions />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
